/*
getQuestions.js
获取三个拓展问题
 */

import BaseURL from "./BaseURL";

const getQuestions = async ({query= ''}) => {
    try {
        const response = await BaseURL.post('api/questions/', {query:query});
        const response_data = response.data;
        return response_data.questions;
    } catch (error) {
        console.log(error)
    }
};

export default getQuestions;